// extracted by mini-css-extract-plugin
export var text = "_be-0";